import React, { useEffect, useRef } from "react";

export default function LiveKitVideo({
  trackRef,
  muted = false,
  mirror = false,
  objectFit = "cover",
  className,
}) {
  const videoRef = useRef(null);
  const track = trackRef?.publication?.track ?? null;
  const isMuted = trackRef?.publication?.isMuted ?? false;

  useEffect(() => {
    const el = videoRef.current;
    if (!el) return;

    if (!track || isMuted) {
      el.srcObject = null;
      return;
    }

    try {
      if (typeof track.attach === "function") track.attach(el);
      else if (track.mediaStreamTrack) {
        el.srcObject = new MediaStream([track.mediaStreamTrack]);
      }
      el.play().catch(() => {});
    } catch (_) {}

    return () => {
      try {
        if (typeof track.detach === "function") track.detach(el);
      } catch (_) {}
      el.srcObject = null;
    };
  }, [track, isMuted]);

  return (
    <video
      ref={videoRef}
      autoPlay
      playsInline
      muted={muted}
      className={className}
      style={{
        width: "100%",
        height: "100%",
        objectFit,
        transform: mirror ? "scaleX(-1)" : "none",
      }}
    />
  );
}
